
export class DataPoint {
    data: any[];
    label: string;
    fill: boolean;
    showLine: boolean;
    hidden: boolean;
    backgroundColor: any;
    borderColor: any;
    borderWidth: number;
}




// WEBPACK FOOTER //
// ./src/app/globaltrends/datapoint.ts